import "@hotwired/turbo-rails";
import "trix";
import "@rails/actiontext";
import "./controllers";

import { application } from "./controllers/application";
import Alpine from "@alpinejs/csp";
import { intersect } from "@alpinejs/intersect";
import { focus } from "@alpinejs/focus";

import home from "./home";
import cookieConsent from "./cookie_consent";

// Lazy load Chart.js only when needed
// This function will be called by chart controllers when they initialize
let chartJsLoadingPromise = null;

window.loadChartJs = async function () {
  // If already loaded, return immediately
  if (window.Chart) {
    return window.Chart;
  }

  // If currently loading, wait for the existing promise
  if (chartJsLoadingPromise) {
    return chartJsLoadingPromise;
  }

  // Start loading Chart.js
  chartJsLoadingPromise = (async () => {
    try {
      const {
        Chart,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        LineElement,
        PointElement,
        Filler,
        RadialLinearScale,
        DoughnutController,
        PieController,
        BarController,
        LineController,
      } = await import("chart.js");

      // Register Chart.js components
      Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        LineElement,
        PointElement,
        Filler,
        RadialLinearScale,
        DoughnutController,
        PieController,
        BarController,
        LineController,
      );

      // Make Chart.js available globally for Stimulus controllers
      window.Chart = Chart;
      console.log("Chart.js loaded successfully");
      return Chart;
    } catch (error) {
      console.error("Failed to load Chart.js:", error);
      chartJsLoadingPromise = null; // Reset on error so retry is possible
      throw error;
    }
  })();

  return chartJsLoadingPromise;
};

Alpine.plugin(intersect);
Alpine.plugin(focus);
window.Alpine = Alpine;

Alpine.data("home", home);
Alpine.data("cookieConsent", cookieConsent);

document.addEventListener("DOMContentLoaded", () => {
  window.Alpine.start();
});

export { application };
